import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "./Header.css"; // Ensure the CSS is linked

const Header = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  // Function to handle logo click
  const handleLogoClick = () => {
    navigate("/"); // Navigate to the home page (hotdeals)
  };

  return (
    <header className="header">
      {/* Logo on the left */}
      <div className="logo-container" onClick={handleLogoClick} style={{ cursor: "pointer" }}>
        <img src="/logo.png" alt="Logo" className="logo" />
      </div>

      {/* Website title and tagline */}
      <div className="title-container">
        <h1>Deals From Deals</h1>
        <p>The ultimate destination for top savings.</p>
      </div>
    </header>
  );
};

export default Header;